"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveGroupSegment = resolveGroupSegment;
function resolveGroupSegment({ group, election, segment }) {
    const district = election?.districts?.find((candidate) => candidate.key === segment);
    if (district) {
        const calculators = group.calculators.filter((item) => "district" in item && item.district?.key === district.key);
        if (calculators.length > 1)
            return { kind: "calculator-picker", district, calculators };
        const only = calculators[0];
        return only ? { kind: "calculator", key: only.key } : undefined;
    }
    if (group.calculators.some((item) => item.key === segment)) {
        return { kind: "calculator", key: segment };
    }
    return undefined;
}
